import AddressItem from '../../../Domain/AddressItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import AddressService from '../../../Services/AddressService';

export default class EditAddressWindowDescription {
  static titleForCreate = 'Add New Address';
  static titleForEdit = 'Edit Address';
  static finishButtonLabel = 'Save Address';
  static messageOnSuccess = 'Address has been saved.';
  static itemType = AddressItem;
  static entityName = 'Address';
  static nameField = 'Name';
  static idField = 'AddressId';
  static serviceFunction = (edited) => AddressService.EditAddress(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Address information',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Line1',
          label: 'Street',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'City',
          label: 'City',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TypeCode',
          label: 'Type',
          className: 'col-12',
          type: InputTypesEnum.AddressTypeLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'State',
          label: 'State',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CountryId',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PostalCode',
          label: 'Postal Code',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}
